export enum EFormEventType {
	afterSubmit,
	beforeSubmit
}
